export default __webpack_public_path__ + "static/media/plain-sticker-S.f89945af.png";